import {FC} from 'react';
import {Box, Flex} from '@chakra-ui/react';

import {pad} from '../../DateTimePicker.utils';
import {TimeField} from '../TimeField';

interface IProps {
  selected: Date | null;
  onChange: (part: 'hours' | 'minutes', value: string) => void;
}

export const TimeRow: FC<IProps> = ({selected, onChange}) => (
  <Flex
    align={'center'}
    gap={'8px'}
    mt={'12px'}
    pt={'12px'}
    borderTop={'thin solid'}
    borderColor={'{colors.borderDefault}'}
  >
    <Box fontSize={'14px'} fontWeight={600} color={'{colors.textSecondary}'}>
      Time:
    </Box>
    <TimeField
      max={23}
      value={selected ? pad(selected.getHours()) : ''}
      onChange={(v) => onChange('hours', v)}
    />
    <Box color={'{colors.textTertiary}'}>:</Box>
    <TimeField
      max={59}
      value={selected ? pad(selected.getMinutes()) : ''}
      onChange={(v) => onChange('minutes', v)}
    />
  </Flex>
);
